module.exports = function getResource(label, vars = []) {
    let resources = {
        installments: `or 4 interest-free payments of ${vars[0]}`,
        testCardDiscount: `or ${vars[0]} off your Sephora order when you open and use a Sephora Credit Card today.¹`,
        testCardDiscountBasketText: `or ${vars[0]} off when you open and use your Sephora Credit Card on this purchase today.¹`,
        testSeeDetails: 'See details',
        learnMore: 'Learn more',
        testCreditCardMessageBody: 'Earn 4% back in rewards when you use your Sephora Credit Card at Sephora.'
    };

    return resources[label];
};
